import { useLocale } from "../providers/LocaleProvider";

const APP_NAME = "CapCut SRT";
const APP_VERSION = "0.1.0";
const REPO_URL = "/";

/**
 * Footer component displaying project name, semver version, and repo link.
 * Uses semantic <footer> element for SEO and accessibility.
 */
export function Footer() {
  const { t } = useLocale();

  return (
    <footer className="app-footer">
      <a href="/" className="footer-name">{APP_NAME}</a>
      <span className="footer-version">
        {t("footer.version")} {APP_VERSION}
      </span>
      <a
        className="footer-repo"
        href={REPO_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("footer.repo")}
      </a>
    </footer>
  );
}
